// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-SingleClient-socialBlock-___socialBlock__container___1sm_d"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SingleClient/socialBlock/socialBlock.css
// module id = 1081
// module chunks = 0